/**
 * Catálogo híbrido (propuesta 1) — espejo del helper server.
 * Por módulo: 1–3 single_select + 1 open_text opcional (contacto va fuera).
 * Cambiar preguntas aquí (y en server/app/helpers/supportFormCatalogHelper.js).
 */

export const MAX_SUPPORT_QUESTIONS = 4;

export const MODULE_KEYS = [
  'technology',
  'alternative',
  'experience',
  'innovation',
  'assistance',
  'financial',
  'vision',
  'regulation',
];

/** Pregunta abierta original (`support.form.mode=static`). No vive en AdditionalSupportPanel. */
export const STATIC_SUPPORT_QUESTIONS = {
  technology: {
    labelKey: 'semanticSearch.form.technology.static',
    label: '¿Cuál es el nivel de madurez técnica (TRL) o sector de tu proyecto?',
  },
  alternative: {
    labelKey: 'semanticSearch.form.alternative.static',
    label: '¿Qué tipo de recurso o sistema actual buscas sustituir?',
  },
  experience: {
    labelKey: 'semanticSearch.form.experience.static',
    label: '¿En qué región geográfica o ecosistema aplicarás esta solución?',
  },
  innovation: {
    labelKey: 'semanticSearch.form.innovation.static',
    label: '¿Tu propuesta cuenta con propiedad intelectual o patente en trámite?',
  },
  assistance: {
    labelKey: 'semanticSearch.form.assistance.static',
    label: '¿En qué área específica (legal, técnica, comercial) requieres la guía?',
  },
  financial: {
    labelKey: 'semanticSearch.form.financial.static',
    label: '¿Qué monto aproximado o etapa de inversión buscas?',
  },
  vision: {
    labelKey: 'semanticSearch.form.vision.static',
    label: '¿Qué tipo de datos o reportes de mercado específicos necesitas consultar?',
  },
  regulation: {
    labelKey: 'semanticSearch.form.regulation.static',
    label: '¿Cuáles son tus países o mercados de destino prioritarios?',
  },
};

export const SUPPORT_FORM_CATALOG = {
  technology: {
    questions: [
      {
        key: 'trl',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.technology.trl',
        label: '¿Cuál es el nivel de madurez técnica (TRL) de tu proyecto?',
        options: [
          { value: '1_3', labelKey: 'semanticSearch.form.technology.trl.1_3', label: 'TRL 1–3 (investigación)' },
          { value: '4_6', labelKey: 'semanticSearch.form.technology.trl.4_6', label: 'TRL 4–6 (prototipo)' },
          { value: '7_9', labelKey: 'semanticSearch.form.technology.trl.7_9', label: 'TRL 7–9 (despliegue)' },
          { value: 'unknown', labelKey: 'semanticSearch.form.technology.trl.unknown', label: 'Aún no lo sé' },
        ],
      },
      {
        key: 'sector',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.technology.sector',
        label: '¿En qué sector aplica tu proyecto?',
        options: [
          { value: 'energy', labelKey: 'semanticSearch.form.technology.sector.energy', label: 'Energía' },
          { value: 'water', labelKey: 'semanticSearch.form.technology.sector.water', label: 'Agua' },
          { value: 'agri', labelKey: 'semanticSearch.form.technology.sector.agri', label: 'Agro / forestal' },
          { value: 'waste', labelKey: 'semanticSearch.form.technology.sector.waste', label: 'Residuos / circular' },
          { value: 'other', labelKey: 'semanticSearch.form.technology.sector.other', label: 'Otro' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.technology.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
  alternative: {
    questions: [
      {
        key: 'substitute',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.alternative.substitute',
        label: '¿Qué tipo de recurso o sistema actual buscas sustituir?',
        options: [
          { value: 'energy', labelKey: 'semanticSearch.form.alternative.substitute.energy', label: 'Energía' },
          { value: 'water', labelKey: 'semanticSearch.form.alternative.substitute.water', label: 'Agua' },
          { value: 'materials', labelKey: 'semanticSearch.form.alternative.substitute.materials', label: 'Materiales' },
          { value: 'process', labelKey: 'semanticSearch.form.alternative.substitute.process', label: 'Proceso productivo' },
          { value: 'other', labelKey: 'semanticSearch.form.alternative.substitute.other', label: 'Otro' },
        ],
      },
      {
        key: 'scale',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.alternative.scale',
        label: '¿A qué escala buscas la sustitución?',
        options: [
          { value: 'pilot', labelKey: 'semanticSearch.form.alternative.scale.pilot', label: 'Piloto / local' },
          { value: 'plant', labelKey: 'semanticSearch.form.alternative.scale.plant', label: 'Planta / instalación' },
          { value: 'territory', labelKey: 'semanticSearch.form.alternative.scale.territory', label: 'Territorial / regional' },
          { value: 'unknown', labelKey: 'semanticSearch.form.alternative.scale.unknown', label: 'Aún no lo sé' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.alternative.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
  experience: {
    questions: [
      {
        key: 'region',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.experience.region',
        label: '¿En qué región geográfica aplicarás esta solución?',
        options: [
          { value: 'latam', labelKey: 'semanticSearch.form.experience.region.latam', label: 'América Latina' },
          { value: 'africa', labelKey: 'semanticSearch.form.experience.region.africa', label: 'África' },
          { value: 'asia', labelKey: 'semanticSearch.form.experience.region.asia', label: 'Asia' },
          { value: 'europe', labelKey: 'semanticSearch.form.experience.region.europe', label: 'Europa' },
          { value: 'global', labelKey: 'semanticSearch.form.experience.region.global', label: 'Varias / global' },
        ],
      },
      {
        key: 'ecosystem',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.experience.ecosystem',
        label: '¿En qué tipo de ecosistema aplicarás la solución?',
        options: [
          { value: 'rural', labelKey: 'semanticSearch.form.experience.ecosystem.rural', label: 'Rural / comunitario' },
          { value: 'urban', labelKey: 'semanticSearch.form.experience.ecosystem.urban', label: 'Urbano / industrial' },
          { value: 'coastal', labelKey: 'semanticSearch.form.experience.ecosystem.coastal', label: 'Costero / insular' },
          { value: 'mixed', labelKey: 'semanticSearch.form.experience.ecosystem.mixed', label: 'Mixto' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.experience.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
  innovation: {
    questions: [
      {
        key: 'ip',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.innovation.ip',
        label: '¿Tu propuesta cuenta con propiedad intelectual o patente en trámite?',
        options: [
          { value: 'none', labelKey: 'semanticSearch.form.innovation.ip.none', label: 'No' },
          { value: 'process', labelKey: 'semanticSearch.form.innovation.ip.process', label: 'En trámite' },
          { value: 'granted', labelKey: 'semanticSearch.form.innovation.ip.granted', label: 'Concedida' },
        ],
      },
      {
        key: 'kind',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.innovation.kind',
        label: '¿Qué tipo de innovación es?',
        options: [
          { value: 'product', labelKey: 'semanticSearch.form.innovation.kind.product', label: 'Producto' },
          { value: 'process', labelKey: 'semanticSearch.form.innovation.kind.process', label: 'Proceso' },
          { value: 'model', labelKey: 'semanticSearch.form.innovation.kind.model', label: 'Modelo de negocio' },
          { value: 'social', labelKey: 'semanticSearch.form.innovation.kind.social', label: 'Social / organizacional' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.innovation.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
  assistance: {
    questions: [
      {
        key: 'area',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.assistance.area',
        label: '¿En qué área específica (legal, técnica, comercial) requieres la guía?',
        options: [
          { value: 'legal', labelKey: 'semanticSearch.form.assistance.area.legal', label: 'Legal' },
          { value: 'technical', labelKey: 'semanticSearch.form.assistance.area.technical', label: 'Técnica' },
          { value: 'commercial', labelKey: 'semanticSearch.form.assistance.area.commercial', label: 'Comercial' },
          { value: 'other', labelKey: 'semanticSearch.form.assistance.area.other', label: 'Otra' },
        ],
      },
      {
        key: 'accompaniment',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.assistance.accompaniment',
        label: '¿Qué tipo de acompañamiento busca?',
        options: [
          { value: 'consult', labelKey: 'semanticSearch.form.assistance.accompaniment.consult', label: 'Consulta puntual' },
          { value: 'process', labelKey: 'semanticSearch.form.assistance.accompaniment.process', label: 'Acompañamiento de proceso' },
          { value: 'training', labelKey: 'semanticSearch.form.assistance.accompaniment.training', label: 'Capacitación / taller' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.assistance.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
  financial: {
    questions: [
      {
        key: 'ticket',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.financial.ticket',
        label: '¿Qué monto aproximado busca?',
        options: [
          { value: 'lt50k', labelKey: 'semanticSearch.form.financial.ticket.lt50k', label: 'Menos de 50 mil' },
          { value: '50_250k', labelKey: 'semanticSearch.form.financial.ticket.50_250k', label: '50 a 250 mil' },
          { value: '250k_1m', labelKey: 'semanticSearch.form.financial.ticket.250k_1m', label: '250 mil a 1 millón' },
          { value: 'gt1m', labelKey: 'semanticSearch.form.financial.ticket.gt1m', label: 'Más de 1 millón' },
          { value: 'unknown', labelKey: 'semanticSearch.form.financial.ticket.unknown', label: 'Aún no lo sé' },
        ],
      },
      {
        key: 'stage',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.financial.stage',
        label: '¿En qué etapa de inversión está su proyecto?',
        options: [
          { value: 'pre', labelKey: 'semanticSearch.form.financial.stage.pre', label: 'Preinversión' },
          { value: 'inv', labelKey: 'semanticSearch.form.financial.stage.inv', label: 'Inversión' },
          { value: 'ops', labelKey: 'semanticSearch.form.financial.stage.ops', label: 'Operación / escala' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.financial.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
  vision: {
    questions: [
      {
        key: 'data_need',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.vision.data_need',
        label: '¿Qué tipo de datos o reportes de mercado específicos necesitas consultar?',
        options: [
          { value: 'market', labelKey: 'semanticSearch.form.vision.data_need.market', label: 'Mercado' },
          { value: 'climate', labelKey: 'semanticSearch.form.vision.data_need.climate', label: 'Clima / escenarios' },
          { value: 'policy', labelKey: 'semanticSearch.form.vision.data_need.policy', label: 'Política / regulación' },
          { value: 'other', labelKey: 'semanticSearch.form.vision.data_need.other', label: 'Otro' },
        ],
      },
      {
        key: 'horizon',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.vision.horizon',
        label: '¿Para qué horizonte los necesita?',
        options: [
          { value: 'now', labelKey: 'semanticSearch.form.vision.horizon.now', label: 'Decisión inmediata' },
          { value: 'mid', labelKey: 'semanticSearch.form.vision.horizon.mid', label: 'Planificación 1 a 5 años' },
          { value: 'long', labelKey: 'semanticSearch.form.vision.horizon.long', label: 'Escenarios de largo plazo' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.vision.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
  regulation: {
    questions: [
      {
        key: 'market',
        type: 'single_select',
        required: true,
        labelKey: 'semanticSearch.form.regulation.market',
        label: '¿Cuáles son tus mercados de destino prioritarios?',
        options: [
          { value: 'latam', labelKey: 'semanticSearch.form.regulation.market.latam', label: 'América Latina' },
          { value: 'na', labelKey: 'semanticSearch.form.regulation.market.na', label: 'Norteamérica' },
          { value: 'eu', labelKey: 'semanticSearch.form.regulation.market.eu', label: 'Europa' },
          { value: 'asia', labelKey: 'semanticSearch.form.regulation.market.asia', label: 'Asia' },
          { value: 'other', labelKey: 'semanticSearch.form.regulation.market.other', label: 'Otro' },
        ],
      },
      {
        key: 'instrument',
        type: 'single_select',
        required: false,
        labelKey: 'semanticSearch.form.regulation.instrument',
        label: '¿Qué tipo de instrumento le interesa?',
        options: [
          { value: 'standard', labelKey: 'semanticSearch.form.regulation.instrument.standard', label: 'Norma / estándar' },
          { value: 'policy', labelKey: 'semanticSearch.form.regulation.instrument.policy', label: 'Política pública' },
          { value: 'permit', labelKey: 'semanticSearch.form.regulation.instrument.permit', label: 'Permiso / licencia' },
        ],
      },
      {
        key: 'comment',
        type: 'open_text',
        required: false,
        labelKey: 'semanticSearch.form.regulation.comment',
        label: 'Comentario adicional (opcional)',
      },
    ],
  },
};

export const getSupportFormQuestions = (moduleKey) => {
  const key = String(moduleKey || '').toLowerCase();
  const def = SUPPORT_FORM_CATALOG[key] || SUPPORT_FORM_CATALOG.technology;
  const questions = (def.questions || []).slice(0, MAX_SUPPORT_QUESTIONS);
  const openSeen = { n: 0 };
  return questions.filter((q) => {
    if (q.type !== 'open_text') return true;
    openSeen.n += 1;
    return openSeen.n === 1;
  });
};

export const getStaticSupportQuestion = (moduleKey) => {
  const key = String(moduleKey || '').toLowerCase();
  return STATIC_SUPPORT_QUESTIONS[key] || STATIC_SUPPORT_QUESTIONS.technology;
};

export const resolveOptionLabel = (question, value, t) => {
  const opt = (question.options || []).find((o) => o.value === value);
  if (!opt) return value;
  return t(opt.labelKey, { defaultValue: opt.label || value });
};

export const buildAnswersPayload = (questions, answerMap, t) => {
  return (questions || []).map((q) => {
    const raw = answerMap[q.key] ?? (q.type === 'multi_select' ? [] : '');
    let valueLabel = '';
    if (q.type === 'open_text') {
      valueLabel = raw ? String(raw) : '';
    } else if (Array.isArray(raw)) {
      valueLabel = raw.map((v) => resolveOptionLabel(q, v, t)).join(', ');
    } else if (raw) {
      valueLabel = resolveOptionLabel(q, raw, t);
    }
    const translated = t(q.labelKey, {
      defaultValue: q.label || q.key,
      returnObjects: true,
    });
    const label = translated && typeof translated === 'object'
      ? (translated.label || q.label || q.key)
      : translated;
    return {
      key: q.key,
      type: q.type,
      question_id: q.id || null,
      label,
      value: raw,
      value_label: valueLabel,
    };
  });
};

